import { RootState } from "interfaces/generics.type";
import { useRouter } from "next/router";
import Script from "next/script";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { isBusinessHP } from "util/helper/helper";
import { getLSItem } from "util/localStorageUtils";
import { isLoginPage } from "util/url/checkRouteInclude";
import yieldToMain from "../../util/lodash/yieldToMain";

export default function KlaviyoScript() {
  const [initializeKlaviyo, setInitializeKlaviyo] = useState(false);
  const { refreshStatus, businessCustomer } = useSelector((store: RootState) => store.authenticationState);
  const { pathname, asPath } = useRouter();
  const isBusinessPage = isBusinessHP(asPath);

  useEffect(() => {
    yieldToMain().then(() => {
      if (refreshStatus === "complete" && businessCustomer === false && !isBusinessPage && !isLoginPage(pathname) && !getLSItem("isBusinessCustomer")) {
        setInitializeKlaviyo(true);
      }
    });
  }, [refreshStatus]);

  if (!initializeKlaviyo) {
    return null;
  }

  return (
    <>
      <Script
        src={`https://static.klaviyo.com/onsite/js/${process.env.NEXT_PUBLIC_VAR_ENV === "production" ? "Y48Sni" : "WvLgyU"}/klaviyo.js`}
        strategy="lazyOnload"
      />
      <Script
        dangerouslySetInnerHTML={{
          __html: `
                !function(){if(!window.klaviyo){window._klOnsite=window._klOnsite||[];try{window.klaviyo=new Proxy({},{get:function(n,i){return"push"===i?function(){var n;(n=window._klOnsite).push.apply(n,arguments)}:function(){for(var n=arguments.length,o=new Array(n),w=0;w<n;w++)o[w]=arguments[w];var t="function"==typeof o[o.length-1]?o.pop():void 0,e=new Promise((function(n){window._klOnsite.push([i].concat(o,[function(i){t&&t(i),n(i)}]))}));return e}}})}catch(n){window.klaviyo=window.klaviyo||[],window.klaviyo.push=function(){var n;(n=window._klOnsite).push.apply(n,arguments)}}}}();
                `,
        }}
        strategy="lazyOnload"
      />
    </>
  );
}
